<template>
  <a class="link" :href="sectionPathsById[value.section._ref]" :target="value.blank && '_blank'">{{ text }}</a>
</template>

<script setup>
import { inject } from 'vue'

const { sectionPathsById } = inject('context')
const { value, text } = defineProps({
  value: Object,
  text: String,
})
</script>
